/* eslint-disable */
import { ofType, ActionsObservable } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { StatisticsStats } from "../actions";
import { API_URL } from "../config/settings";
import { Headers } from "../utilites/Headers";
import { toast } from "react-toastify";

export const getStatisticsSessionsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_STATISTICS_SESSIONS),
    switchMap(({ payload }) =>  // Add payload parameter
      ajax({
        url: `${API_URL}/admin/dashboard/stats/users`, // Change from /admin/stats/users
        method: "POST", // Change from GET to POST
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { startDate: "", endDate: "" }), // Add body with dates
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Transform API response to match component expectations
            const transformedPayload = {
              ...response.payload,
              // Fix countByRole mapping issues
              countByRole: {
                ...response.payload.countByRole,
                owners: response.payload.countByRole?.owner || 0, // API: "owner" -> Component: "owners"
                landlordsWithTenant: response.payload.countByRole?.landlordWithTenant || 0, // Already matches
                tenant: response.payload.countByRole?.tenant || 0, // Already matches
                communityManagers: response.payload.countByRole?.communityManager || 0, // API: "communityManager" -> Component: "communityManagers"
              },
              // Fix other field mappings
              usersWithoutProperty: response.payload.countByRole?.userWithoutProperty || 0, // API: "countByRole.userWithoutProperty" -> Component: "usersWithoutProperty"
              notifications: response.payload.allowedNotifications || 0, // API: "allowedNotifications" -> Component: "notifications"
              deletedWithProperties: response.payload.deletedUsersWithProperties || 0, // API: "deletedUsersWithProperties" -> Component: "deletedWithProperties"
              deletedWithoutProperties: response.payload.deletedUsersWithoutProperties || 0, // API: "deletedUsersWithoutProperties" -> Component: "deletedWithoutProperties"
              // Keep locations with fallback (not in API response, so keeping existing fallback)
              locations: response.payload.locations || 0,
            };
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "sessions",
                loading: false,
                ...transformedPayload,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            
            toast.error(err?.response?.error);
            obs.complete();
          })
        )
      )
    )
  );

export const getActiveUsersEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_ACTIVE_USERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/stats/active-users`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "activeUsers",
                loading: false,
                ...response.payload,  // Spread response.payload instead of response
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload.activeUsersCount);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error(err?.response?.error)
            obs.complete();
          })
        )
      )
    )
  );

export const getDownloadsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_APP_DOWNLOADS),
    switchMap(({ onSuccess }) =>
      ajax({
        url: `${API_URL}/admin/active-users`,
        method: "GET",
        headers: Headers.get_auth(),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "activeUsers",
                loading: false,
                ...response,
              },
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error(err?.response?.error)
            obs.complete();
          })
        )
      )
    )
  );
export const getPropertiesStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_PROPERTIES_STATS),
    switchMap(({ payload }) =>  // Add payload parameter
      ajax({
        url: `${API_URL}/admin/dashboard/stats/properties`, // Correct new endpoint
        method: "POST", // Change from GET to POST
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { startDate: "", endDate: "" }), // Add body
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "properties",
                loading: false,
                ...response.payload, // Spread response.payload
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            
            toast.error(err?.response?.error);
            obs.complete();
          })
        )
      )
    )
  );


export const getCommunitiesStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_COMMUNITIES_STATS),
    switchMap(({ payload }) =>  // Add payload parameter
      ajax({
        url: `${API_URL}/admin/dashboard/stats/communities`, // Update endpoint
        method: "POST", // Change from GET to POST
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { startDate: "", endDate: "" }), // Add body
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "communities",
                loading: false,
                ...response.payload,
                // Transform API response to match component expectations:
                communitiesByCountry: response.payload.byCountry,
                communitiesByCity: response.payload.byCity,
                communitiesByMembersCount: response.payload.byMembersRanges,
                communitiesByNoticesCount: response.payload.byNoticesRanges,
                communitiesByCalendarEventsCount: response.payload.byCalendarEventsRanges,
                communitiesByPollsCount: response.payload.byPollsRanges,
                communitiesByMeetingsCount: response.payload.byMeetingsRanges,
                communitiesByFilesCount: response.payload.byFilesRanges,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            
            toast.error(err?.response?.error);
            obs.complete();
          })
        )
      )
    )
  );

export const getSubscriptionsStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_SUBSCRIPTIONS_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/stats/subscriptions`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { startDate: "", endDate: "" }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Transform API response to expected component format
            const transformedData = {
              // User subscription data
              users: {
                free: response.payload.freeUsers || 0,
                monthly: response.payload.monthlySubscriberUsers || 0,
                annual: response.payload.yearlySubscriberUsers || 0,
                total: response.payload.usersCount || 0
              },
              // Community subscription data  
              communities: {
                free: response.payload.freeCommunities || 0,
                subscribed: response.payload.subscribedCommunities || 0,
                total: response.payload.communitiesCount || 0
              },
              // Keep original data for reference
              raw: response.payload,
              // Community payment stats if available
              communityPaymentStats: response.payload.communityPaymentStats || []
            };

            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "subscriptions",
                loading: false,
                ...transformedData,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load subscription stats");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

  
export const getWalletsStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_WALLETS_STATS),
    switchMap(({ onSuccess }) =>
      ajax({
        url: `${API_URL}/admin/stats/wallets`,
        method: "GET",
        headers: Headers.get_auth(),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "wallets",
                loading: false,
                ...response,
              },
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getBankAccountStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_COMMUNITIES_STATS),
    switchMap(({ onSuccess }) =>
      ajax({
        url: `${API_URL}/admin/stats/bank-accounts`,
        method: "GET",
        headers: Headers.get_auth(),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "bankAccounts",
                loading: false,
                ...response,
              },
            });
            if (onSuccess) onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getAppDownloadsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_APP_DOWNLOADS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/stats/downloads`, // This is correct - it should hit the v2 endpoint
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { startDate: "", endDate: "" }), // Add default values
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "appDownloads",
                loading: false,
                downloads: response.payload, // Use response.payload to get the array
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            
            toast.error(err?.response?.error);
            obs.complete();
          })
        )
      )
    )
  );

  
export const getAppGrowthStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.APP_GROWTH_STATS),
    switchMap(({}) =>
      ajax({
        url: `${API_URL}/admin/stats/monthly`,
        method: "GET",
        headers: Headers.get_auth(),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "growth",
                loading: false,
                ...response,
              },
            });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );
export const getNotificationsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_NOTIFICATIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/custom-notifications/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Map the new API response structure to expected format
            const mappedResponse = {
              notifications: {
                docs: response.payload.docs || [],
                totalPages: response.payload.totalPages || 1,
                page: response.payload.page || 1,
              },
              totalPages: response.payload.totalPages || 1,
            };
            
            obs.next({
              type: StatisticsStats.GET_NOTIFICATIONS_SUCCESS,
              payload: mappedResponse,
              totalPages: mappedResponse.totalPages,
            });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );
export const createNotificationEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.CREATE_NOTIFICATION),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/notifications/send`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            
            payload.onSuccess();
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            toast.error(err?.response?.error)
            obs.complete();
          })
        )
      )
    )
  );
export const getActiveUsersListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_ACTIVE_USERS_LIST),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/active-users/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_ACTIVE_USERS_LIST_SUCCESS,
              payload: response.users,
            });
            if (payload.onSuccess) payload?.onSuccess(response.users);

            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getMostActiveUsersListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_MOST_ACTIVE_USERS_LIST),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/stats/most-active-users/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload || { 
          page: 1, 
          limit: 20, 
          startDate: "", 
          endDate: "" 
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_MOST_ACTIVE_USERS_LIST_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.error("Error in getMostActiveUsersListEpic:", err);
            toast.error(err?.response?.error || "Failed to load most active users");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );


export const getReceiversEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_RECEIVERS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/notifications/${payload.id}/receivers`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          page: payload.page,
          limit: payload.limit,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            
            obs.next({
              type: StatisticsStats.GET_RECEIVERS_SUCCESS,
              payload: response,
            });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );
export const getUserAutoCompleteEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.USER_AUTOCOMPLETE),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/users-autocomplete?pattern=${payload}`,
        method: "GET",
        headers: Headers.get_auth(),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.USER_AUTOCOMPLETE_SUCCESS,
              payload: response.users,
            });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );
export const getPropertiesEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_PROPERTIES),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/properties/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            if (payload.onSuccess) payload.onSuccess(response.properties);
            obs.next({
              type: StatisticsStats.GET_PROPERTIES_SUCCESS,
              payload: response.properties,
              locationsWithCoordinates: response.locations,
              totalPagesProperties: response.properties.totalPages,
            });
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );
export const getSubscribedUsersListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_SUBSCRIBED_USERS_LIST),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/subscribed-users/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Determine state key based on subscription type
            let stateType = "subscribedUsers"; // default fallback
            if (payload?.type === "free") {
              stateType = "freeUsers";
            } else if (payload?.type === "monthly") {
              stateType = "monthlyUsers";
            } else if (payload?.type === "yearly") { // Use 'yearly' instead of 'annual'
              stateType = "annualUsers";
            }
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: stateType,
                loading: false,
                ...response.payload,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load subscribed users");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );
export const getSubscribedCommunitiesListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_SUBSCRIBED_COMMUNITIES_LIST),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/subscribed-communities/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Determine state key based on subscription type
            let stateType = "subscribedCommunities"; // default fallback
            if (payload?.type === "free") {
              stateType = "freeCommunities";
            } else if (payload?.type === "monthly") {
              stateType = "monthlyCommunities";
            } else if (payload?.type === "yearly") {
              stateType = "annualCommunities";
            }
            
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: stateType,
                loading: false,
                ...response.payload,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load subscribed communities");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getCommunitiesListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_COMMUNITIES_LIST),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/communities/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          page: payload?.page || 1,
          limit: payload?.limit || 20,
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_COMMUNITIES_LIST_SUCCESS,
              payload: {
                ...response.payload,
                page: payload?.page || 1,
                isFirstPage: (payload?.page || 1) === 1
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            obs.next({
              type: StatisticsStats.GET_COMMUNITIES_LIST_ERROR,
              payload: err,
            });
            toast.error(err?.response?.error || "Failed to load communities list");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );

export const getUsersListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_USERS_LIST),
    switchMap(({ payload }) => {
      const requestBody = {
        name: payload?.name || "",
        email: payload?.email || "",
        country: payload?.country || "",
        city: payload?.city || "",
        os: payload?.os || "",
        langs: Array.isArray(payload?.langs) ? payload.langs : [],
        subscriptionTypes: Array.isArray(payload?.subscriptionTypes) ? payload.subscriptionTypes : [],
        enabledNotifications: Array.isArray(payload?.enabledNotifications) ? payload.enabledNotifications : [],
        phoneNumber: payload?.phoneNumber || "",
        role: payload?.role || "",
        startDate: payload?.startDate || "",
        endDate: payload?.endDate || "",
        page: payload?.page || 1,
        limit: payload?.limit || 10, // Changed default to match component
      };

      // Add activeNow only if it's explicitly set to true
      if (payload?.activeNow === true) {
        requestBody.activeNow = true;
      }

      return ajax({
        url: `${API_URL}/admin/dashboard/users/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(requestBody),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_USERS_LIST_SUCCESS,
              payload: {
                ...response.payload,
                page: payload?.page || 1,
                isFirstPage: (payload?.page || 1) === 1
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.error('API Error Details:', {
              status: err.status,
              response: err.response,
              message: err.message,
              requestBody: requestBody
            });
            obs.next({
              type: StatisticsStats.GET_USERS_LIST_ERROR,
              payload: err,
            });
            toast.error(err?.response?.error || "Failed to load users list");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      );
    })
  );

export const getPropertiesListEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_PROPERTIES_LIST),
    switchMap(({ payload }) => {
      const requestBody = {
        user: "",
        page: payload?.page || 1,
        limit: payload?.limit || 20, // Always include limit
      };

      console.log('Sending properties list request body:', requestBody);

      return ajax({
        url: `${API_URL}/admin/dashboard/properties/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(requestBody),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            // Check if the response indicates success
            if (response.success === false) {
              // Treat as error even if HTTP status is 200
              console.error('API returned error response:', response);
              obs.next({
                type: StatisticsStats.GET_PROPERTIES_LIST_ERROR,
                payload: {
                  message: response.message || 'API returned error',
                  response: response
                },
              });
              toast.error(response.message || "Failed to load properties list");
              if (payload?.onError) payload.onError(response);
              obs.complete();
              return;
            }

            // Success case - ensure payload exists
            const responsePayload = response.payload || {};
            obs.next({
              type: StatisticsStats.GET_PROPERTIES_LIST_SUCCESS,
              payload: {
                ...responsePayload,
                page: payload?.page || 1,
                isFirstPage: (payload?.page || 1) === 1
              },
            });
            if (payload?.onSuccess) payload.onSuccess(responsePayload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.error('Properties List API Error Details:', {
              status: err.status,
              response: err.response,
              message: err.message,
              requestBody: requestBody
            });
            obs.next({
              type: StatisticsStats.GET_PROPERTIES_LIST_ERROR,
              payload: err,
            });
            toast.error(err?.response?.error || "Failed to load properties list");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      );
    })
  );

export const getAppSessionsStatsEpic = (action$) =>
  action$.pipe(
    ofType(StatisticsStats.GET_APP_SESSIONS_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/dashboard/stats/sessions`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify({
          page: 1,
          limit: 20,
          startDate: payload?.startDate || "",
          endDate: payload?.endDate || "",
        }),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: StatisticsStats.GET_STATISTICS_SUCCESS,
              payload: {
                type: "appSessions",
                loading: false,
                ...response.payload,
              },
            });
            if (payload?.onSuccess) payload.onSuccess(response.payload);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.error('App Sessions API Error Details:', {
              status: err.status,
              response: err.response,
              message: err.message
            });
            toast.error(err?.response?.error || "Failed to load app sessions data");
            if (payload?.onError) payload.onError(err);
            obs.complete();
          })
        )
      )
    )
  );
